var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RCard',{staticClass:"subscriptions-tab q-pa-lg"},[_c('CustomMetaData',{attrs:{"entity-id":_vm.id,"entity-name":"vendor"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }